import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class CustomDateAdapter extends NativeDateAdapter {
  private static readonly DEFAULT_LOCALE = 'en';
  private readonly dayNamesByLocale: { [key: string]: string[] } = {
    en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    ch: ['日', '一', '二', '三', '四', '五', '六'],
    kr: ['일', '월', '화', '수', '목', '금', '토'],
    jp: ['日', '月', '火', '水', '木', '金', '土'],
  };

  private readonly monthNamesByLocale: { [key: string]: string[] } = {
    en: [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December',
    ],
    ch: [
      '一月', '二月', '三月', '四月', '五月', '六月',
      '七月', '八月', '九月', '十月', '十一月', '十二月',
    ],
    kr: [
      '1월', '2월', '3월', '4월', '5월', '6월',
      '7월', '8월', '9월', '10월', '11월', '12월',
    ],
    jp: [
      '1月', '2月', '3月', '4月', '5月', '6月',
      '7月', '8月', '9月', '10月', '11月', '12月',
    ],
  };

  constructor(platform: Platform) {
    super(CustomDateAdapter.DEFAULT_LOCALE, platform);
  }

  /**
   *
   * @param style
   */
  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = this.locale || CustomDateAdapter.DEFAULT_LOCALE;
    return this.monthNamesByLocale[locale] || this.monthNamesByLocale[CustomDateAdapter.DEFAULT_LOCALE];
  }

  /**
   *
   * @param style
   */
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    const locale = this.locale || CustomDateAdapter.DEFAULT_LOCALE;
    const dayNames = this.dayNamesByLocale[locale] || this.dayNamesByLocale[CustomDateAdapter.DEFAULT_LOCALE];

    if (style === 'long') {
      return dayNames.map((_, index) => this.getFullDayName(index, locale));
    }
    return dayNames;
  }

  /**
   *
   * @param date
   * @param displayFormat
   */
  override format(date: Date, displayFormat: Object): string {
    const locale = this.locale || CustomDateAdapter.DEFAULT_LOCALE;
    const monthNames = this.monthNamesByLocale[locale] || this.monthNamesByLocale[CustomDateAdapter.DEFAULT_LOCALE];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${year}`;
  }

  /**
   *
   * @param dayIndex
   * @param locale
   */
  private getFullDayName(dayIndex: number, locale: string): string {
    const fullDayNames: { [key: string]: string[] } = {
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      ch: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      kr: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
      jp: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
    };

    return fullDayNames[locale]?.[dayIndex] || fullDayNames[CustomDateAdapter.DEFAULT_LOCALE][dayIndex];
  }
}
